import { Box, Text } from '@factorialco/deprecated-design-system'

export type FinanceEmoji = '🫥' | '💸' | '💰' | '📚' | '🤝' | '☕' | '🏦'

interface FinanceEmpetyChartWidgetProps {
  icon: FinanceEmoji
  text: string
  description?: string
}

export const FinanceEmpetyChartWidget = ({
  icon,
  text,
  description = 'This chart has no data',
}: FinanceEmpetyChartWidgetProps) => {
  return (
    <Box
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="s12"
      height="full"
      width="full"
      minHeight="s300"
      style={{ marginBottom: '8px' }}
    >
      <Box
        borderRadius={{ all: 'abs012' }}
        padding="s0"
        border={{ all: { color: 'grey200', style: 'solid', width: 's1' } }}
        width="s40"
        height="s40"
        textAlign="center"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
      >
        <Text.Header1>{icon}</Text.Header1>
      </Box>
      <Box textAlign="center" flexDirection="column" gap="s2">
        <Text.Normal weight="medium">{text}</Text.Normal>
        <Text.Normal size="200">{description}</Text.Normal>
      </Box>
    </Box>
  )
}
